import React from 'react'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { compose, ReduxWrapper } from 'common-data/datahelpers'
// import { FAIcon } from './FAIcon'

import styles from './DataCardHeader.less'

class DataCardHeaderPlain extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    text: pt.string,
    children: pt.any
  })

  static defaultProps = {
    text: '?'
  }

  render () {
    const { text, children } = this.props

    const cardStyle = {
      gridColumnStart: 1,
      gridColumnEnd: -1
    }

    if (children) {
      return (
        <React.Fragment>
          <div style={cardStyle} className={styles.datacard}>
            <h2>{text}</h2>
          </div>
          <div style={cardStyle} className={styles.datacarddesc}>
            {children}
          </div>
        </React.Fragment>
      )
    } else {
      cardStyle.marginBottom = '20px'
      return (
        <div style={cardStyle} className={styles.datacard}>
          <h2>{text}</h2>
        </div>
      )
    }
  }
}

export const DataCardHeader = compose(
  ReduxWrapper([
  ],
  [])
)(DataCardHeaderPlain)
